var exports = {
  "kL": "SimplePageSkeleton.module__container___UC1lSF",
  "wx": "SimplePageSkeleton.module__header___UC1lSF",
  "BU": "SimplePageSkeleton.module__headerCompact___UC1lSF",
  "Kh": "SimplePageSkeleton.module__headerLeading___UC1lSF",
  "$s": "SimplePageSkeleton.module__headerActions___UC1lSF",
  "Ge": "SimplePageSkeleton.module__rows___UC1lSF",
  "nM": "SimplePageSkeleton.module__row___UC1lSF",
  "pt": "SimplePageSkeleton.module__rowDetails___UC1lSF",
  "y6": "SimplePageSkeleton.module__channelGroups___UC1lSF",
  "Rf": "SimplePageSkeleton.module__channelGroupHeading___UC1lSF",
  "S7": "SimplePageSkeleton.module__channelCard___UC1lSF",
  "Fp": "SimplePageSkeleton.module__channelCardHeader___UC1lSF",
  "ut": "SimplePageSkeleton.module__channelCardStream___UC1lSF",
  "P9": "SimplePageSkeleton.module__channelCardFooter___UC1lSF",
  "YX": "SimplePageSkeleton.module__tableContent___UC1lSF",
  "KE": "SimplePageSkeleton.module__toolbar___UC1lSF",
  "d0": "SimplePageSkeleton.module__toolbarLeft___UC1lSF",
  "O5": "SimplePageSkeleton.module__toolbarRight___UC1lSF",
  "wY": "SimplePageSkeleton.module__tableWrapper___UC1lSF",
  "p": "SimplePageSkeleton.module__tableViewport___UC1lSF",
  "uV": "SimplePageSkeleton.module__tableSurface___UC1lSF",
  "QS": "SimplePageSkeleton.module__tableSurfaceSelectable___UC1lSF",
  "iA": "SimplePageSkeleton.module__tableFooter___UC1lSF",
  "vl": "SimplePageSkeleton.module__tableFooterLeft___UC1lSF",
  "C5": "SimplePageSkeleton.module__tableFooterRight___UC1lSF",
  "tT": "SimplePageSkeleton.module__tableHeadRow___UC1lSF",
  "ts": "SimplePageSkeleton.module__tableHeadCell___UC1lSF",
  "bg": "SimplePageSkeleton.module__tableBody___UC1lSF",
  "jD": "SimplePageSkeleton.module__tableRow___UC1lSF",
  "xR": "SimplePageSkeleton.module__tableCell___UC1lSF",
  "MN": "SimplePageSkeleton.module__tableNameCell___UC1lSF",
  "mg": "SimplePageSkeleton.module__tableNameInfo___UC1lSF",
  "Yo": "SimplePageSkeleton.module__tableActionsCell___UC1lSF",
};

module.exports = exports;
